module.exports = __webpack_public_path__ + "img/123.a0116b47.jpg";